<style>
  #MainDivCat *{
    font-weight: bolder;
    font-size: 14px;
    list-style: none;
  }
</style>

<div id="MainDivCat">
  <ul>
    <li class="MyMoeinListCat_Li">

      <div class="MyMoeinListCat_Div">
        <span class="MyMoeinListCat_Span">ریشه</span>

      </div>

      <app-Chart_Check_Co
        (On_Change_Action)="OnGet_Change_Action($event)"
        [inner_Chart]="DataList_Chart">

      </app-Chart_Check_Co>

    </li>
  </ul>
</div>
